import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Footer.scss';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();

  const role = user?.role_name;
  const guideLinks =
    role === 'mentor' ? [{ label: 'Guía de uso', path: '/guia/mentor' }]
    : role === 'mentee' ? [{ label: 'Guía de uso', path: '/guia/mentee' }]
    : [{ label: 'Guía del mentor', path: '/guia/mentor' }, { label: 'Guía del mentee', path: '/guia/mentee' }];

  const quickLinks = [
    { label: 'Inicio', path: '/' },
    { label: 'Mensajería', path: '/mensajeria' },
    ...guideLinks,
  ];

  return (
    <footer className="footer">
      <div className="footer-row">
        <div className="footer-left">
          <div className="footer-brand" onClick={() => navigate('/')}>
            <img src="/img/mitsui_logo_corporate.svg" alt="MITSUI & CO." className="footer-logo" />
            <span className="footer-tagline">Plataforma de Mentoría</span>
          </div>

          <span className="footer-sep" aria-hidden />

          <nav className="footer-links">
            {quickLinks.map(link => (
              <button key={link.path} type="button" className="footer-link" onClick={() => navigate(link.path)}>
                {link.label}
              </button>
            ))}
          </nav>
        </div>

        <p className="footer-copyright">
          © {currentYear} Mitsui &amp; Co., Ltd. All Rights Reserved.
        </p>
      </div>

      <div className="footer-powered">
        <span className="footer-powered-label">Desarrollado por</span>
        <img src="/img/logo_cornerstone.svg" alt="Cornerstone" className="footer-kuali" />
      </div>
    </footer>
  );
};

export default Footer;
